import layout from '@/components/common/layout';
import studyList from '../views/study/list';

export default [
    {
        path: '/study',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "学习记录",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'study_list',// 子选项
                    }
                },
                component: studyList,
            },
        ]
    },
];
